import { ApiClient } from "../config/axiosConfig";
import {
  IExternalEmployee,
  IFilterTimesheet,
  ITask,
  ITimesheetResponse,
  IUpdateTask,
} from "../models/Timesheet";

export const timesheetService = {
  getTimesheetWeek: async (
    params: IFilterTimesheet,
  ): Promise<ITimesheetResponse> => {
    const response = await ApiClient.GET(`/timesheets/week`, params);
    return response;
  },
  createTimesheet: async (data: ITask) => {
    const response = await ApiClient.POST(`/timesheets`, data);
    return response;
  },
  updateTimesheet: async (id: string, data: IUpdateTask) => {
    const response = await ApiClient.PUT(`/timesheets/${id}`, data);
    return response;
  },
  deleteTimesheet: async (id: string) => {
    const response = await ApiClient.DELETE(`/timesheets/${id}`);
    return response;
  },
  getExternalEmployees: async () => {
    const response = await ApiClient.GET<IExternalEmployee[]>(
      `/timesheets/external-employees`,
    );
    return response;
  },
  createExternalEmployee: async (data: Omit<IExternalEmployee, "id">) => {
    const response = await ApiClient.POST<IExternalEmployee>(
      `/timesheets/external-employees`,
      data,
    );
    return response;
  },
  updateExternalEmployee: async (
    id: number,
    data: Omit<IExternalEmployee, "id">,
  ) => {
    const response = await ApiClient.PUT<IExternalEmployee>(
      `/timesheets/external-employees/${id}`,
      data,
    );
    return response;
  },
  deleteExternalEmployee: async (id: number) => {
    const response = await ApiClient.DELETE(
      `/timesheets/external-employees/${id}`,
    );
    return response;
  },
};
